var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MatDialogRef } from '@angular/material';
import { BaseComponent } from '../base.component';
import { MobileIFrameExportPdfAlertModalData } from './mobile.iframe.export.pdf.alert.modal.provider';
var MobileIFrameExportPdfAlertModal = /** @class */ (function (_super) {
    __extends(MobileIFrameExportPdfAlertModal, _super);
    function MobileIFrameExportPdfAlertModal(modalRef, data) {
        var _this = _super.call(this) || this;
        _this.modalRef = modalRef;
        _this.data = Object.assign({}, data);
        return _this;
    }
    MobileIFrameExportPdfAlertModal.prototype.openUrl = function ($event) {
        var _this = this;
        if ($event && $event.stopPropagation) {
            $event.stopPropagation();
        }
        window.open(this.data.url, '_blank');
        setTimeout(function () {
            _this.close();
        });
    };
    MobileIFrameExportPdfAlertModal.prototype.close = function () {
        this.modalRef.close();
    };
    return MobileIFrameExportPdfAlertModal;
}(BaseComponent));
export { MobileIFrameExportPdfAlertModal };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mobile.iframe.export.pdf.alert.modal/mobile.iframe.export.pdf.alert.modal.ts.pre-build-optimizer.js